<ng-container *ngIf="dataSource">
    <div class="content-card">
        <ng-container *ngFor="let item of dataSource | async; let index = index">
            <div class="card-info" (click)="handleCardAction(item, index)">
                <ng-container *ngFor="let header of headers">
                    <div *ngIf="header.label === 'header'; else others">
                        <div class="bg-color-background-1 d-flex border-r-8 card-title">
                            <div class="left-subtitle-block bg-color-primary-1"></div>
                            <div class="d-flex full-width py-03">
                                <sit-icon [icon]="icon.login_user_y" class="text-blue-1 ml-16"
                                    [sizeClass]="'icon-size-24'" [alt]="''"></sit-icon>
                                <h3
                                    class="flex-grow text-weight-600 text-size-18 ml-8 text-md-size-18 text-color-title align-self-center m-0">
                                    {{ item[header.key] }}
                                </h3>
                            </div>
                        </div>
                    </div>

                    <ng-template #others>
                        <div class="card-info-item">
                            <span class="card-info-subtitle">
                                {{ header.label }}
                            </span>
                            <span class="card-info-text">
                                {{ item[header.key] }}
                            </span>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </ng-container>
    </div>
</ng-container>